var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"ed-card",attrs:{"shadow":_vm.shadow,"bodyStyle":_vm.bodyStyle}},[(_vm.showHeader && _vm.isTitle)?_c('div',{staticClass:"ed-card--header",attrs:{"slot":"header"},slot:"header"},[_vm._t("header",function(){return [_c('div',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._t("operate")],2)]})],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }